var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Painter',{attrs:{"json-array":_vm.jsonArray,"poster-key":_vm.posterKey,"app-id":_vm.appId}})}
var staticRenderFns = []

export { render, staticRenderFns }